// Global callback for when update is available
let onUpdateAvailableCallback = null;
let hasReloadedOnce = false;

export function setOnUpdateAvailable(callback) {
  onUpdateAvailableCallback = callback;
}

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = '/sw.js';
      
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('HELCOO PWA: Service Worker registered successfully', registration.scope);
          
          // Check for updates immediately
          registration.update();
          
          // Check for updates every 5 minutes (increased from 2 to reduce refresh frequency)
          setInterval(() => {
            registration.update();
          }, 300000);
          
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('HELCOO PWA: New content available!');
                  // Notify the app that an update is available instead of auto-reloading
                  if (onUpdateAvailableCallback) {
                    onUpdateAvailableCallback();
                  }
                  // Store the waiting worker for later activation
                  window.waitingServiceWorker = installingWorker;
                } else {
                  console.log('HELCOO PWA: Content is cached for offline use.');
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('HELCOO PWA: Service Worker registration failed:', error);
        });
    });
    
    // Listen for controller change - reload only ONCE to prevent infinite loops
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hasReloadedOnce) {
        hasReloadedOnce = true;
        console.log('HELCOO PWA: Controller changed, reloading once...');
        // Store flag in sessionStorage to prevent reload loop
        const reloadCount = parseInt(sessionStorage.getItem('sw_reload_count') || '0');
        if (reloadCount < 2) {
          sessionStorage.setItem('sw_reload_count', String(reloadCount + 1));
          window.location.reload();
        } else {
          console.log('HELCOO PWA: Skipping reload to prevent loop');
          sessionStorage.removeItem('sw_reload_count');
        }
      }
    });
  }
}

// Function to apply the update when user chooses
export function applyUpdate() {
  if (window.waitingServiceWorker) {
    window.waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
  } else {
    // Fallback: clear caches and reload
    forceUpdate();
    window.location.reload();
  }
}

// Force update and clear all caches
export function forceUpdate() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      // Send message to clear cache
      if (registration.active) {
        registration.active.postMessage({ type: 'CLEAR_CACHE' });
      }
      // Force update
      registration.update();
    });
  }
  // Also clear browser caches
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
